export enum GodziType {
  None = 0,
  RatioPrize = 1,
  FreeGame = 2,
  FreeSpin = 3,
}
export enum GodziDropSoundType {
  godziRoar = 'godziRoar',
  godziCoins = 'godziCoins',
  godziCoinBgm = 'godziCoinBgm',
  godziShowPrize = 'godziShowPrize',
  godziVictory = 'godziVictory',
  godziOpenEye = 'godziOpenEye',
}
